import { render, staticRenderFns } from "./BusinessGroup.vue?vue&type=template&id=40371167&scoped=true"
import script from "./BusinessGroup.vue?vue&type=script&lang=js"
export * from "./BusinessGroup.vue?vue&type=script&lang=js"
import style0 from "./BusinessGroup.vue?vue&type=style&index=0&id=40371167&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40371167",
  null
  
)

export default component.exports